(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layout-footer"]) return;
  try {
    
  (() => {
    const earlyStartsAt = 1793505600000;
    const publicStartsAt = 1795755600000;
    const expiresAt = 1796101200000;
    let phaseTimer;
    const setText = (element, selector, value) => {
      const target = element.querySelector(selector);
      if (target && target.textContent !== value) target.textContent = value;
    };
    const updateBlackFriday = () => {
      clearTimeout(phaseTimer);
      const now = Date.now();
      const phase = now >= expiresAt ? 'default' : now >= publicStartsAt ? 'public' : now >= earlyStartsAt ? 'early' : 'signup';
      document.querySelectorAll('[data-bf-2026-strip]').forEach((strip) => {
        if (phase === 'default') {
          const wrapper = strip.closest('[id^="shopify-section-"]') || strip;
          wrapper.hidden = true;
          wrapper.style.display = 'none';
          return;
        }
        setText(strip, '[data-bf-heading]', strip.dataset[`${phase}Heading`]);
        setText(strip, '[data-bf-dates]', strip.dataset[`${phase}Dates`]);
        setText(strip, '[data-bf-cta]', strip.dataset[`${phase}Cta`]);
      });
      document.querySelectorAll('[data-bf-2026-newsletter]').forEach((newsletter) => {
        setText(newsletter, '[data-newsletter-headline]', newsletter.dataset[`${phase}Headline`]);
        setText(newsletter, '[data-newsletter-description]', newsletter.dataset[`${phase}Description`]);
        if (phase === 'default') newsletter.removeAttribute('data-bf-2026-newsletter');
      });
      const nextBoundary = [earlyStartsAt, publicStartsAt, expiresAt].find((boundary) => boundary > now);
      if (nextBoundary) phaseTimer = setTimeout(updateBlackFriday, Math.min(nextBoundary - now, 2147483647));
    };
    updateBlackFriday();
    window.addEventListener('pageshow', updateBlackFriday);
    document.addEventListener('shopify:section:load', updateBlackFriday);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateBlackFriday();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
